import { render } from "./DollarSignIcon.vue?vue&type=template&id=622437d5&scoped=true"
import script from "./DollarSignIcon.vue?vue&type=script&lang=js"
export * from "./DollarSignIcon.vue?vue&type=script&lang=js"

import "./DollarSignIcon.vue?vue&type=style&index=0&id=622437d5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-622437d5"]])

export default __exports__